var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaseItemBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 146,
    viewBox: "0 0 124 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24,
    filter: "url(#filter0_f_2023_650)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4816 82.7735L37.867 96.1783C35.6194 97.572 32.6745 96.8572 31.2892 94.5821C30.6126 93.4709 30.4083 92.1316 30.7223 90.8687L34.038 77.5369C35.2349 72.7238 38.4827 68.7008 42.9061 66.5519L66.4952 55.0908C67.595 54.5566 68.0553 53.221 67.5239 52.1084C67.0931 51.207 66.1237 50.7026 65.1491 50.8733L38.8697 55.4733C33.5277 56.4087 28.043 54.9168 23.8762 51.3959L15.5515 44.3613C13.5233 42.6475 13.2494 39.6004 14.9397 37.5553C15.7618 36.5606 16.9461 35.9431 18.226 35.8419L43.5974 33.8348C45.3899 33.693 46.9492 32.5463 47.6329 30.8673L57.3586 6.9835C58.3624 4.51842 61.1556 3.34791 63.5976 4.36909C64.7698 4.85942 65.703 5.79985 66.1916 6.9835L76.0457 30.8673C76.7384 32.5463 78.3038 33.693 80.0968 33.8348L105.619 35.853C108.252 36.0611 110.224 38.3863 110.025 41.0464C109.93 42.326 109.334 43.5133 108.37 44.346L88.9551 61.1129C87.5875 62.293 86.9954 64.1511 87.4211 65.9199L93.4712 91.038C94.0963 93.6324 92.5232 96.2411 89.9585 96.8656C88.7255 97.1662 87.4242 96.9577 86.3408 96.2881L64.4761 82.7735C62.9411 81.8251 61.0115 81.8251 59.4816 82.7735Z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2023_650)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.5,
    cy: 159,
    rx: 51,
    ry: 17,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2023_650",
    x: -2.16846,
    y: -12,
    width: 128.207,
    height: 125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_2023_650"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2023_650",
    x: -69.5,
    y: 62,
    width: 262,
    height: 194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_2023_650"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseItemBackground);
export default __webpack_public_path__ + "static/media/case-item-background.37b97a444ffa6c76f423f48239ac2635.svg";
export { ForwardRef as ReactComponent };